module.exports = __webpack_public_path__ + "static/oathbow-bc97be6df66add8795f37f4a2efd301f.jpeg";